export default __webpack_public_path__ + "static/media/FoxLakeLogo.ab0d3e44.png";